import { Component, OnInit } from '@angular/core';
import { SharedAttachmentsService } from '../shared-attachments/shared-attachments.service';
import { Location } from '@angular/common';
import { getDepartmentTypeByRouteName } from '@core/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-shared-attachments-detail',
    templateUrl: './shared-attachments-detail.component.html',
    styleUrls: ['./shared-attachments-detail.component.scss'],
})
export class SharedAttachmentsDetailComponent implements OnInit {
    attachment: any;
    loading: boolean = false;
    constructor(
        private attachmentsService: SharedAttachmentsService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        private toastrService: NbToastrService,
        private translateService: TranslateService
    ) {}

    ngOnInit(): void {
        this.getAttachmentDetail();
    }

    getAttachmentDetail() {
        const url = this.router.url.split('/');
        url.shift();
        const [deparmentRoute] = url;

        const departmentType = getDepartmentTypeByRouteName(deparmentRoute);
        const sessionType = this.route.snapshot.params['sessionType'];
        const docId = this.route.snapshot.params['docId'];

        if (!departmentType || !sessionType || !docId) {
            this.toastrService.danger(
                this.translateService.instant('ALERT.ERROR.DESCRIPTION'),
                this.translateService.instant('ALERT.ERROR.DESCRIPTION')
            );
            this.location.back();
        }

        this.loading = true;
        this.attachmentsService.getAttachmentsDetail(departmentType, sessionType, docId).subscribe(
            (response) => {
                this.loading = false;
                if (response.status_code !== 0) {
                    this.toastrService.danger(
                        this.translateService.instant('ALERT.ERROR.DESCRIPTION'),
                        this.translateService.instant('ALERT.ERROR.DESCRIPTION')
                    );
                    this.location.back();
                    return;
                }

                this.attachment = response.registers.object;
            },
            () => {
                this.loading = false;
            }
        );
    }
}
